import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, debounceTime, distinctUntilChanged, map, tap, timeout } from 'rxjs';
import { FromApi, ILanguage, Paginated } from '../interfaces';
import { ENVIRONMENT } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly endpoint: string = `${ENVIRONMENT.api.gatewayBaseUrl}/api/languages`;
  private readonly requestTimeout: number = ENVIRONMENT.api.writeTimeout;
  private readonly debounceTime: number = 1000;

  public constructor(private readonly httpClient: HttpClient) { }

  public list(): Observable<ILanguage[]> {
    const REQUEST_URL = this.endpoint

    return this.httpClient
      .get<Paginated<FromApi<ILanguage>>>(REQUEST_URL, {
        withCredentials: true,
      })
      .pipe(
        debounceTime(this.debounceTime),
        timeout(this.requestTimeout),
        distinctUntilChanged(),
        map(value => value.data.map(v => ({
          id: v.id,
          name: v.attributes.name,
          code: v.attributes.code
        } satisfies ILanguage)))
      )
  }
}
